import Swiper from 'swiper/bundle';

$(document).ready(() => {
    if (jQuery('.quote__slider').length) {
        const swiper = new Swiper(".quote__slider", {
            loop: true,
        });
    }
});